var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.499 14.5l-3.5-3.5-1.167 1.167 4.667 4.666 10-10-1.167-1.166L7.499 14.5z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNDk4NyAxNC41TDMuOTk4NyAxMUwyLjgzMjAzIDEyLjE2NjdMNy40OTg3IDE2LjgzMzRMMTcuNDk4NyA2LjgzMzM1TDE2LjMzMiA1LjY2NjY5TDcuNDk4NyAxNC41WiIgZmlsbD0iIzAwMzM2NiIvPgo8L3N2Zz4K";
export { SvgCheckmark as ReactComponent };